import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { message } from 'antd';

import withGetService from '../../../../hoc/with-get-service';
import withPatchService from '../../../../hoc/with-patch-service';
import withDeleteService from '../../../../hoc/with-delete-service';
import DepthBotView from './depth-bot-view';
import { compose } from '../../../../../utils';
import Spinner from '../../../../spinner';
import {
    depthBotsCreatePath,
    depthBotsEditPath, depthBotsPath,
    personalAreaPath,
    STATUS_BOT_RUNNING,
    STATUS_BOT_STOPPED,
} from '../../../../../constants';
import cancelDepthBotOrdersAction from '../../../../../actions/cancelDepthBotOrders.actions';
import fetchDepthBotsAction from '../../../../../actions/getDepth.actions';
import deleteDepthBotActions from '../../../../../actions/deleteDepthBot.actions';
import switchStatusDepthAction from '../../../../../actions/switchStatusDepth.actions';
import stopAllBotsDepthAction from '../../../../../actions/stopAllBotsDepth.action';

export class DepthBotContainer extends Component {
    static defaultProps = {
        t: () => {},
        history: {},
        switchStatus: false,
        successDeleteBot: false,
        successStopAllDepthBots: false,
        depthBots: [],
        loading: true,
        error: false,
        disabledStartAllBtn: false,
        fetchDepthBots: () => {},
        fetchDeleteDepthBot: () => {},
        fetchswitchStatusDepth: () => {},
        fetchStopAllBotsDepth: () => {},
        cancelDepthBotOrders: () => {},
    };

    static propTypes = {
        t: PropTypes.func,
        history: PropTypes.object,
        depthBots: PropTypes.arrayOf(PropTypes.object),
        switchStatus: PropTypes.bool,
        successDeleteBot: PropTypes.bool,
        successStopAllDepthBots: PropTypes.bool,
        loading: PropTypes.bool,
        error: PropTypes.bool,
        disabledStartAllBtn: PropTypes.bool,
        fetchDepthBots: PropTypes.func,
        fetchDeleteDepthBot: PropTypes.func,
        fetchswitchStatusDepth: PropTypes.func,
        fetchStopAllBotsDepth: PropTypes.func,
        cancelDepthBotOrders: PropTypes.func,
    };

    state = {
        areUSureModal: false,
        deleteBtnId: null,
        cancelBtnId: null,
        filterBotsData: null,
        yesBtnAreUSureModalItem: '',
    };

    componentDidMount() {
        const { fetchDepthBots } = this.props;
        fetchDepthBots();
    }

    componentDidUpdate(prevProps) {
        const {
            fetchDepthBots, switchStatus, successDeleteBot, successStopAllDepthBots,
        } = this.props;
        if (
            switchStatus !== prevProps.switchStatus
            || successDeleteBot !== prevProps.successDeleteBot
            || successStopAllDepthBots !== prevProps.successStopAllDepthBots
        ) {
            fetchDepthBots();
        }
    }

    createNewBot = () => {
        const { history } = this.props;
        history.push(`${personalAreaPath}${depthBotsCreatePath}`);
    };

    stopAllBots = () => {
        const { areUSureModal } = this.state;
        this.setState({
            yesBtnAreUSureModalItem: 'stopAllBots',
            areUSureModal: !areUSureModal,
        });
    };

    startAllBots = () => {
        const { areUSureModal } = this.state;
        this.setState({
            yesBtnAreUSureModalItem: 'startAllBots',
            areUSureModal: !areUSureModal,
        });
    };

    switchAreUSureModal = () => {
        const { areUSureModal } = this.state;
        this.setState({
            areUSureModal: !areUSureModal,
        });
    };

    yesBtnAreUSureModal = () => {
        const {
            fetchDeleteDepthBot,
            fetchswitchStatusDepth,
            fetchStopAllBotsDepth,
            cancelDepthBotOrders,
            t,
        } = this.props;
        const {
            cancelBtnId, deleteBtnId, filterBotsData, yesBtnAreUSureModalItem,
        } = this.state;
        this.setState({
            areUSureModal: false,
        });

        const stopData = {
            status: 'STOPPED',
        };

        const startData = {
            status: 'RUNNING',
        };

        if (yesBtnAreUSureModalItem === 'deleteDepthBot') {
            fetchDeleteDepthBot(deleteBtnId, t);
        }
        if (yesBtnAreUSureModalItem === 'switchStatusDepth') {
            fetchswitchStatusDepth(filterBotsData, filterBotsData.id, t);
        }
        if (yesBtnAreUSureModalItem === 'stopAllBots') {
            fetchStopAllBotsDepth(stopData, t);
        }

        if (yesBtnAreUSureModalItem === 'startAllBots') {
            fetchStopAllBotsDepth(startData, t);
        }

        if (yesBtnAreUSureModalItem === 'cancelOrders') {
            cancelDepthBotOrders(cancelBtnId, t);
        }
    };

    switchStatusDepth = id => {
        const { depthBots } = this.props;
        const filterBotsData = depthBots.filter(item => item.id === id);
        const filterBotsDataObject = Object.assign({}, filterBotsData[0]);
        const currentStatus = filterBotsDataObject.status === STATUS_BOT_RUNNING ? STATUS_BOT_STOPPED : STATUS_BOT_RUNNING;
        this.setState(
            {
                yesBtnAreUSureModalItem: 'switchStatusDepth',
                filterBotsData: {
                    ...filterBotsDataObject,
                    status: currentStatus,
                },
            },
            () => {
                this.switchAreUSureModal();
            },
        );
    };

    deleteDepthBot = id => {
        this.switchAreUSureModal();
        this.setState({
            deleteBtnId: id,
            yesBtnAreUSureModalItem: 'deleteDepthBot',
        });
    };

    cancelOrders = id => {
        this.switchAreUSureModal();
        this.setState({
            cancelBtnId: id,
            yesBtnAreUSureModalItem: 'cancelOrders',
        });
    };

    editDepthBot = id => {
        const { history } = this.props;
        history.push(`${personalAreaPath}${depthBotsEditPath}/${id}`);
    };

    cannotChahgeBot = () => {
        const { t } = this.props;
        message.error(t('createBot.NeedTurnOffBot'), 2);
    };

    goToPreview = id => {
        const { history } = this.props;
        history.push(`${personalAreaPath}${depthBotsPath}/${id}`);
    }

    render() {
        const { areUSureModal } = this.state;
        const {
            depthBots, loading, error, disabledStartAllBtn,
        } = this.props;

        const hasData = !(loading || error);

        const spinner = loading ? <Spinner /> : null;
        const content = hasData ? (
            <DepthBotView
                botsData={depthBots}
                areUSureModal={areUSureModal}
                disabledStartAllBtn={disabledStartAllBtn}
                stopAllBots={this.stopAllBots}
                startAllBots={this.startAllBots}
                createNewBot={this.createNewBot}
                cancelOrders={this.cancelOrders}
                yesBtnAreUSureModal={this.yesBtnAreUSureModal}
                switchAreUSureModal={this.switchAreUSureModal}
                switchStatusDepth={this.switchStatusDepth}
                deleteDepthBot={this.deleteDepthBot}
                editDepthBot={this.editDepthBot}
                cannotChahgeBot={this.cannotChahgeBot}
                goToPreview={this.goToPreview}
            />
        ) : null;

        return (
            <Fragment>
                {spinner}
                {content}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {
        getDepthBot: { depthBots, loading, error },
        statusDepth: { success: switchStatus },
        deleteDepthBot: { success: successDeleteBot },
        stopAllDepthBots: { success: successStopAllDepthBots, loading: disabledStartAllBtn },
    } = state;
    return {
        depthBots,
        loading,
        error,
        switchStatus,
        successDeleteBot,
        successStopAllDepthBots,
        disabledStartAllBtn,
    };
};

const mapDispatchToProps = (dispatch, { getService, deleteService, patchService }) => bindActionCreators(
    {
        fetchDepthBots: fetchDepthBotsAction(getService),
        fetchDeleteDepthBot: deleteDepthBotActions(deleteService),
        cancelDepthBotOrders: cancelDepthBotOrdersAction(deleteService),
        fetchswitchStatusDepth: switchStatusDepthAction(patchService),
        fetchStopAllBotsDepth: stopAllBotsDepthAction(patchService),
    },
    dispatch,
);

export default compose(
    withTranslation(),
    withDeleteService(),
    withGetService(),
    withPatchService(),
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(DepthBotContainer);
